import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/apiAuth";

const fetchPendingVotesAsync = createAsyncThunk(
  "votingForm/fetchPendingVotes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/votes/pending");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default fetchPendingVotesAsync;
